import React, {
  useState,
  forwardRef,
  useRef,
  useEffect,
  useContext,
  useImperativeHandle,
} from 'react'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import { userContext } from 'global/context/sub-contexts/userContext'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Grid from '@material-ui/core/Grid'
import Card from 'components/index/Card'
import ServerError from 'steps/shared/ServerError'
import FacebookCommentsSection from 'components/FacebookCommentsSection'

import { getPointsForBreak } from 'services/break.js'
import {
  start as serviceStart,
  complete as serviceComplete,
} from 'services/complete.js'

import './Complete.scss'

const Complete = ({
  step,
  breakId,
  points,
  isStarted,
  isComplete,
  onStepStart,
  onStepComplete,
  featuredBreaks,
  isEmbed,
  facebookEnabled = false,
}) => {
  const childRef = useRef()
  const completeRef = useRef(null)
  const [awardedPoints, setAwardedPoints] = useState(0)
  const [serverError, setIsServerError] = useState(false)
  const modal_context = useContext(modalContext)
  const user_context = useContext(userContext)
  const { showSignInModalTab } = modal_context || {}

  // console.log(step)

  const getAwardedPoints = async () => {
    try {
      const awardedPts = await getPointsForBreak(breakId)
      setAwardedPoints(awardedPts.detail)
      console.log('earned Pts: ', awardedPts)
    } catch (e) {
      console.log(e)
      if (e.message === '401') {
        showSignInModalTab()
      } else {
        setIsServerError(true)
      }
    }
  }

  // with the Complete step, once it's unlocked all of it's analytics events fire one after the other
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          initiateCompleteStep()
        }
      },
      { threshold: 0.2 },
    )
    if (completeRef.current) {
      observer.observe(completeRef.current)
    }
  }, [isEmbed, breakId, step.id, isComplete])

  const initiateCompleteStep = async () => {
    if (!isEmbed) {
      getAwardedPoints()
    }

    if (isComplete === false) {
      try {
        const result = await serviceStart(breakId, step.id)
        onStepStart && onStepStart(step, result.detail.attempt)
        const response = await serviceComplete(breakId, step.id)
        console.log('break complete')
        const { totalPoints } = response.detail
        user_context.setPoints(totalPoints)
        onStepComplete && onStepComplete(step.id)
      } catch (e) {
        console.log(e)
        setIsServerError(true)
      }
    }
  }

  let style = {}
  // const bgImg = step && step.image && step.image.id;
  const bgImg = step && step.backgroundImage && step.backgroundImage.id

  if (step && step.backgroundColor) {
    style.backgroundColor = step.backgroundColor
  }

  if (bgImg) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${bgImg})`
  }

  const filteredBreaks = featuredBreaks.slice().filter(b => b.id != breakId)

  return (
    <section className="sponsored-flow-panel" style={style}>
      <div className="complete-step" ref={completeRef}>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} md={12}>
            <div className="container">
              <div className="content">
                <h2>
                  Congrats, you did it!
                  {!isEmbed ? ` You earned ${awardedPoints} points.` : ''}{' '}
                </h2>
                {step && step.headline && (
                  <p dangerouslySetInnerHTML={{ __html: step.headline }}></p>
                )}
              </div>

              <div className="card__slider">
                <SliderComponent className="card__slider" ref={childRef}>
                  {filteredBreaks &&
                    filteredBreaks.map((brk, index) => {
                      return (
                        <Card brk={brk} key={index} thumbnail={false}></Card>
                      )
                    })}
                </SliderComponent>
              </div>
            </div>
          </Grid>
          {facebookEnabled && (
            <Grid item xs={12} md={12}>
              <FacebookCommentsSection
                question={step.commentQuestion || ''}
                editorial={false}
              />
            </Grid>
          )}
        </Grid>
      </div>
      {serverError && <ServerError />}
    </section>
  )
}

const SliderComponent = forwardRef((props, ref) => {
  var sliderRef = {}
  var settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    variableWidth: true,
    dotsClass: 'slick-dots card__slider-dots',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  }

  useImperativeHandle(ref, () => ({
    GotoSlick() {
      sliderRef.slickGoTo(0)
    },
  }))

  return (
    <Slider
      className={'card__slider'}
      ref={slider => (sliderRef = slider)}
      {...settings}
    >
      {props.children.map((obj, index) => {
        return <React.Fragment key={index}>{obj}</React.Fragment>
      })}
    </Slider>
  )
})

export default Complete
